import http from "@/utils/httpRequest";

// 获取消息中心列表
export const apiMessageList = (params) => {
  return http.post("/message/list", { ...params }, { baseURL });
};
// 获取数量
export const apiMessageGetcount = (params) => {
  return http.get("/message/getCount", { baseURL });
};
// 已读
export const apiurgeconfirmsaveBylist = (params) => {
  return http.post("/urgeconfirm/saveBylist", { ...params }, { baseURL });
};

// 中心首页获取列表
export const apiMessagegetExceptTaskList = (params) => {
  return http.post("/message/getExceptTaskList", { ...params }, { baseURL });
};
